export default {
  DISCLOSURE_FS: 'https://www.flexshopper.com/page/electronic-communication',
  TERMS_FS: 'https://www.flexshopper.com/page/terms-of-use',
  PRIVACY_FS: 'https://www.flexshopper.com/page/privacy',
  MAIN_FS: 'https://WWW.FLEXSHOPPER.COM',
  TERMS_AND_CONDITIONS_AFF: 'https://api.paypair.com/Application_Terms_and_Conditions.pdf',
  ARDITATION_AFF: 'https://api.paypair.com/Arditation_Procision.pdf',
  PRIVACY_AFF: 'https://hcms2.americanfirstfinance.com/wp-content/uploads/2021/02/Privacy-Policy-English-AFF.pdf',
  CONSENT_TO_ELECTRONIC_COMMUNICATION_SNAP: 'https://snapfinance.com/legal/customer-tc#1_consent_to_electronic_transactions',
  PRIVACY_POLICY_SNAP: 'https://snapfinance.com/legal/privacy#privacy_notices',
  TERMS_AND_CONDITIONS_SNAP: 'https://snapfinance.com/legal/customer-tc',
  JURY_TRIAL_SNAP: 'https://snapfinance.com/legal/customer-tc#7_jury_trial_waiver_and_arbitration_clause',
  SMS_TERMS_SNAP: 'https://snapfinance.com/legal/sms-terms-and-conditions',
  TERMS_AND_CONDITIONS_KAFENE: 'https://www.kafene.com/legal/terms-conditions',
  ARBITRATION_AGREEMENT_KAFENE: 'https://www.kafene.com/legal/arbitration-agreement',
  PRIVACY_POLICY_KAFENE: 'https://www.kafene.com/legal/privacy-policy',
  GLBA_PRIVACY_NOTICE_KAFENE: 'https://www.kafene.com/legal/glba-privacy-policy',
  DISCLOSURE_AND_CONSENT_KAFENE: 'https://www.kafene.com/legal/e-sign-disclosure-and-consent',
  PROHIBITED_CONDUCT_KAFENE: 'https://www.kafene.com/legal/prohibited-items-and-conduct',
  MESSAGING_POLICY_KAFENE: 'https://www.kafene.com/legal/sms-policies',
  TERMS_PROGRESSIVE: 'https://progleasing.com/terms/',
  PRIVACY_PROGRESSIVE: 'https://progleasing.com/privacy/',
  ARBITRATION_PROGRESSIVE: 'https://progleasing.com/arbitration-clause/',
  DISCLOSURE_PROGRESSIVE: 'https://progleasing.com/application-disclosure/',
  ELECTRONIC_DISCLOSURE_PROGRESSIVE: 'https://progleasing.com/e-sign-disclosure/'
}
